import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';

import { log } from '../../services/utils';

import Logo from '../Shared/Logo';

import styles from './auth.module.css';

const AuthForm = ( { children } ) => (
	<>
		{ log( 'authForm' ) }
		<div className={ styles.wrapper }>
			<Segment id={ styles.authForm }>
				<Logo className={ styles.logo } labelled />
				{ children }
			</Segment>
		</div>
	</>
);

AuthForm.propTypes = { children: PropTypes.node.isRequired };

export default AuthForm;
